import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useMemo } from "react";
import { useLocation, useNavigate } from "react-router";

import { getSafeQuoteBoardReturnUrl } from "../utils/quote-board-return-url.ts";

export const useQuoteBoardReturn = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const returnTo = useMemo(
		() =>
			getSafeQuoteBoardReturnUrl(
				new URLSearchParams(location.search).get("returnTo"),
			),
		[location.search],
	);

	const returnToQuoteBoard = useCallback((): boolean => {
		if (!returnTo) return false;

		void queryClient.invalidateQueries({ queryKey: ["quote-board-items"] });
		navigate(returnTo);
		return true;
	}, [navigate, queryClient, returnTo]);

	return { returnTo, returnToQuoteBoard } as const;
};
